import { render, staticRenderFns } from "./modelTest.vue?vue&type=template&id=00690afc&scoped=true&"
import script from "./modelTest.vue?vue&type=script&lang=js&"
export * from "./modelTest.vue?vue&type=script&lang=js&"
import style0 from "./modelTest.vue?vue&type=style&index=0&id=00690afc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00690afc",
  null
  
)

export default component.exports